<script setup lang="ts">
  import type { OperatingSystem } from '@/types/operating-system'
  import { getOperatingSystem } from '@/utils/os-utils'
  import { UiButton } from '@logistiek-zonder-papier/lzp-library'
  import { onMounted } from 'vue'

  onMounted(() => {
    openStore(getOperatingSystem())
  })

  //If this page is reached on either ios or android assume the app is not installed
  function openStore(os: OperatingSystem) {
    switch (os) {
      case 'android':
        window.location.href = import.meta.env['VITE_ANDROID_STORE']
        break
      case 'ios':
        window.location.href = import.meta.env['VITE_IOS_STORE']
        break
    }
  }
</script>

<template>
  <div class="container">
    <h1>Om deze functie te gebruiken heb je de app nodig.</h1>

    <UiButton label="IOS app downloaden" variant="link" @click="openStore('ios')" />
    <UiButton label="Android app downloaden" variant="link" @click="openStore('android')" />
  </div>
</template>

<style lang="css" scoped>
  .container {
    max-width: 100%;
    height: 100vh;
    background-color: var(--colours-grey-1);
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    padding: var(--spacing-xl) 0 0 0;
    margin: 0;
  }
</style>
